import React, { Component } from "react"
import ScrollableAnchor, { goToAnchor, configureAnchors } from 'react-scrollable-anchor'
import "./Welcome.scss"

class Welcome extends Component {
    goDown() {
          configureAnchors({ offset: -60, scrollDuration: 1000 })
          goToAnchor('nextgame', false)
    }
    render() {
        return (
            <ScrollableAnchor id="welcome">
            <section className="section section-welcome">
                <div className="padding">
                    <div className="container">
                        <div className="frame">
                            <div className="text">
                                <div className="headline">
                                    מי <span>נגד</span> מי
                                </div>
                                <div className="desc">
                                    המקום היחיד שמאגד את כל מה
                                    שלא באמת חשוב במונדיאל הזה,<br />
                                    <span>אבל ממש כיף לקרוא</span>
                                </div>
                            </div>
                        </div>
                        <div className="arrow" onClick={this.goDown}></div>
                    </div>
                </div>
            </section>
            </ScrollableAnchor>
        )
    }
}

export default Welcome;


// WEBPACK FOOTER //
// ./src/Components/Welcome/Welcome.jsx